import { type ReactElement, type ReactNode } from 'react'
import { ColorInput, Input } from '@mantine/core'
import { IconDisplay } from './IconDisplay'
import { IconEmojiPicker } from './IconEmojiPicker'

export type IconEmojiColorPickerProps = {
  color: string | undefined
  colorError?: ReactNode | undefined
  onColorChange: (color: string) => void
  icon: string | undefined
  iconError?: ReactNode | undefined
  onIconChange: (icon: string) => void
  disableCompanyLogo?: boolean
  withinPortal?: boolean
}

export const IconEmojiColorPicker = ({
  color,
  onColorChange,
  icon,
  onIconChange,
  disableCompanyLogo,
  colorError,
  iconError,
  withinPortal,
}: IconEmojiColorPickerProps): ReactElement => {
  return (
    <Input.Wrapper>
      <IconEmojiPicker
        value={icon}
        onChange={onIconChange}
        placeholder='Select an icon'
        withinPortal={withinPortal}
        disableCompanyLogo={disableCompanyLogo}
      />
      <ColorInput
        label='Icon Background Color'
        value={color}
        onChange={onColorChange}
        popoverProps={{ withinPortal }}
      />
      {icon && <IconDisplay color={color} icon={icon} />}
      {colorError && <Input.Error>{colorError}</Input.Error>}
      {iconError && <Input.Error>{iconError}</Input.Error>}
    </Input.Wrapper>
  )
}
